import CandidateSearchContainer from "../../container/admin/candidate-search";

const CandidateSearch = () => {
    return <CandidateSearchContainer />;
};

export default CandidateSearch;